import "../../nuove-sezioni/fonts.scss";
import styles from "./Lavori.module.scss";
import { lavori as l } from "../../../types/content";
import { Freccia, Media, cx } from "../Icone";
import type { NumeroDato } from "../types";

const Numero = ({ valore, label, evidenza }: NumeroDato) => (
  <div className={styles["lavori__numero"]}>
    <span
      className={cx(styles["lavori__numero-val"], evidenza && styles["lavori__numero-val--pop"])}
    >
      {valore}
    </span>
    <span className={styles["lavori__numero-label"]}>{label}</span>
  </div>
);

const Lavori = () => {
  const f = l.inEvidenza;
  return (
    <div className={styles["lavori"]} id="lavori">
      <section className={styles["lavori__inner"]}>
        <div className={styles["lavori__head"]}>
          <h2 className={styles["lavori__h2"]}>
            {l.titolo} <em className={styles["lavori__serif"]}>{l.titoloCorsivo}</em>
          </h2>
          <p className={styles["lavori__intro"]}>{l.intro}</p>
        </div>

        {/* Progetto in evidenza */}
        <article className={styles["lavori__featured"]}>
          <div className={styles["lavori__featured-testo"]}>
            <ul className={styles["lavori__tags"]}>
              {f.tag.map((t, i) => (
                <li key={t} className={i === 0 ? styles["lavori__tag--pop"] : undefined}>
                  {t}
                </li>
              ))}
            </ul>
            <h3 className={styles["lavori__featured-titolo"]}>{f.titolo}</h3>
            <p className={styles["lavori__featured-desc"]}>{f.testo}</p>
            <div className={styles["lavori__numeri"]}>
              {f.numeri.map((n) => (
                <Numero key={n.label} {...n} />
              ))}
            </div>
            <a className={styles["lavori__btn"]} href={f.link.url}>
              {f.link.testo} <Freccia />
            </a>
          </div>
          <div className={styles["lavori__reel-col"]}>
            {f.reel.map((r, i) => (
              <div
                key={r.etichetta}
                className={cx(styles["lavori__reel"], i % 2 === 1 && styles["lavori__reel--giu"])}
              >
                {r.cover && (
                  <img
                    className={styles["lavori__reel-cover"]}
                    src={r.cover}
                    alt=""
                    loading="lazy"
                  />
                )}
                <span
                  className={cx(
                    styles["lavori__reel-label"],
                    i % 2 === 1
                      ? styles["lavori__reel-label--pop"]
                      : styles["lavori__reel-label--accent"]
                  )}
                >
                  {r.etichetta}
                </span>
                {!r.cover && (
                  <span className={styles["lavori__reel-segnaposto"]}>[{r.segnaposto}]</span>
                )}
                <div className={styles["lavori__reel-dati"]}>
                  <strong>{r.numero}</strong>
                  <span>{r.dettaglio}</span>
                </div>
              </div>
            ))}
          </div>
        </article>

        {/* Altri progetti */}
        <div className={styles["lavori__griglia"]}>
          {l.progetti.map((p) => (
            <article
              key={p.titolo}
              className={cx(styles["lavori__progetto"], styles[`lavori__progetto--${p.stile}`])}
            >
              <ul className={styles["lavori__tags"]}>
                {p.tag.map((t) => (
                  <li key={t}>{t}</li>
                ))}
              </ul>
              <h3 className={styles["lavori__progetto-titolo"]}>{p.titolo}</h3>
              <p className={styles["lavori__progetto-testo"]}>{p.testo}</p>
              {p.numeri && (
                <div className={styles["lavori__progetto-numeri"]}>
                  {p.numeri.map((n) => (
                    <Numero key={n.label} {...n} />
                  ))}
                </div>
              )}
              {p.immagini && (
                <div
                  className={cx(
                    styles["lavori__progetto-img"],
                    styles[`lavori__progetto-img--${p.formato ?? "feed"}`]
                  )}
                >
                  {p.immagini.map((img, i) => (
                    <Media
                      key={i}
                      src={img.src}
                      segnaposto={img.segnaposto}
                      adatta={img.adatta}
                      className={styles["lavori__media"]}
                    />
                  ))}
                </div>
              )}
            </article>
          ))}
        </div>

        {/* Anche web & UI */}
        <div className={styles["lavori__anche"]}>
          <span className={styles["lavori__anche-titolo"]}>{l.anche.titolo}</span>
          <div className={styles["lavori__anche-voci"]}>
            {l.anche.voci.map((v) => (
              <span key={v.nome}>
                <strong>{v.nome}</strong>{" "}
                <span className={styles["lavori__muted"]}>· {v.dettaglio}</span>
              </span>
            ))}
          </div>
          <a className={styles["lavori__link"]} href={l.anche.link.url}>
            {l.anche.link.testo}
          </a>
        </div>
      </section>
    </div>
  );
};

export default Lavori;
